import { createContext, useContext, useState } from "react";
import { Message } from "../assets/interfaces/interfaces";

type Messages = Record<string, Partial<Message>[]>;
type MessagesContextType = {
  messages: Messages;
  setMessages: React.Dispatch<React.SetStateAction<Messages>>;
};

const MessagesContext = createContext<MessagesContextType | undefined>(undefined);

export const MessagesProvider = ({ children }: { children: React.ReactNode }) => {
  const [messages, setMessages] = useState<Messages>({});

  return (
    <MessagesContext.Provider value={{ messages, setMessages }}>
      {children}
    </MessagesContext.Provider>
  );
};
export const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) throw new Error("useMessages must be used within MessagesProvider");
  return context;
};
